type OccupancyDurationStatistic = {
    time_period_under_30_min: number;
    time_period_30_60_min: number;
    time_period_60_90_min: number;
    time_period_90_120_min: number;
    time_period_120_180_min: number;
    time_period_over_180_min: number;
};

type OccupancyTimeframeStatistic = {
    time_period_00_01: number;
    time_period_01_02: number;
    time_period_02_03: number;
    time_period_03_04: number;
    time_period_04_05: number;
    time_period_05_06: number;
    time_period_06_07: number;
    time_period_07_08: number;
    time_period_08_09: number;
    time_period_09_10: number;
    time_period_10_11: number;
    time_period_11_12: number;
    time_period_12_13: number;
    time_period_13_14: number;
    time_period_14_15: number;
    time_period_15_16: number;
    time_period_16_17: number;
    time_period_17_18: number;
    time_period_18_19: number;
    time_period_19_20: number;
    time_period_20_21: number;
    time_period_21_22: number;
    time_period_22_23: number;
    time_period_23_24: number;
};

type OccupancyStatistic = {
    parking_id: string | null;
    parking_name: string | null;
    report_type: OCCUPANCY_REPORT_TYPE;
    card_type: string;
    period_from: string;
    period_to: string;
    count_total: number;
    count_by_duration: OccupancyDurationStatistic;
    count_by_timeframe: OccupancyTimeframeStatistic;
};

enum OCCUPANCY_REPORT_TYPE {
    DAY = 'ONE_DAY',
    TOTAL = 'TOTAL_FOR_PERIOD',
}

type FormattedStatistic = { name: string; number: number };

type TimeframeStatistic = {
    data: FormattedStatistic[];
    min: FormattedStatistic;
    max: FormattedStatistic;
};

type FormattedTimeframeStatistics = {
    timeframeStatistics: TimeframeStatistic | null;
    total: number;
    averagePerHour: number;
};

type DurationStatistics = {
    name: string;
    number: number;
    [key: string]: number | string;
};

type FormattedDurationStatistics = {
    durationStatistics: (DurationStatistics | FormattedStatistic)[];
    total: number;
};

export { OCCUPANCY_REPORT_TYPE };
export type {
    OccupancyStatistic,
    OccupancyDurationStatistic,
    OccupancyTimeframeStatistic,
    FormattedTimeframeStatistics,
    FormattedDurationStatistics,
    FormattedStatistic,
    TimeframeStatistic,
    DurationStatistics,
};
